import { getWifi } from '~/src/api/wifi';

import { ERROR_WIFI, FETCH_WIFI, SET_WIFI } from '../actionTypes/wifi';

const convertPoints = (points) => {
    if (!Array.isArray(points)) {
 return points;
}

    return points.map(point => {
        return {
            ...point,
            name: point.hotspot_name,
            type: 'wifi',
            address: `${point.street}, ${point.house_number}`,
            hours: point.hotspot_worktime,
        };
    });
};

export function fetchWifiList(cityDomain) {
    return async(dispatch) => {
        dispatch({
            type: FETCH_WIFI,
            payload: {
                fetching: true,
            },
        });

        const data = await getWifi(cityDomain);

        if (data.ok) {
            const items = convertPoints(data.data);
            dispatch({
                type: SET_WIFI,
                payload: {
                    fetching: false,
                    fetchError: null,
                    items,
                },
            });
        } else {
            const errorMsg = data.response?.data || 'error';
            dispatch({
                type: ERROR_WIFI,
                payload: {
                    fetching: false,
                    fetchError: errorMsg,
                    items: [],
                },
            });
            console.info('Action: fetchWifiList error', errorMsg);
        }
    };
}
